import DirectionsIcon from "@mui/icons-material/Directions";
import React from "react";
import { ProcessedRestaurant } from "../../../../../../hooks/useProcessedRestaurants";
import { IconCheck, IconClock, IconNavigation, IconPin, IconStar } from "../../../../../shared/icons";
import styles from "./RestaurantItem.module.scss";

interface Props {
  item: ProcessedRestaurant;
  isSelected: boolean;
  isNearest: boolean;
  primaryColor: string;
  onClick: () => void;
  onDirections: () => void;
}

const RestaurantItem = React.forwardRef<HTMLDivElement, Props>(
  ({ item, isSelected, isNearest, primaryColor, onClick, onDirections }, ref) => (
    <div
      ref={ref}
      className={[
        styles.item,
        isSelected ? styles.selected : "",
        !item.isOpen ? styles.closed : "",
      ].filter(Boolean).join(" ")}
      style={isSelected ? { backgroundColor: `${primaryColor}0a` } : {}}
      onClick={onClick}
    >
      <div className={styles.body}>
        {(isNearest || isSelected) && (
          <div className={styles.tags}>
            {isNearest && (
              <span className={`${styles.tag} ${styles.tagNearest}`}>
                <IconNavigation size={9} /> Le plus proche
              </span>
            )}
            {isSelected && (
              <span
                className={`${styles.tag} ${styles.tagSelected}`}
                style={{
                  background: primaryColor,
                  color: "#fff",
                }}
              >
                <IconCheck size={9} />
                <span style={{ color: "#fff" }}>Sélectionné</span>
              </span>
            )}
          </div>
        )}

        <p className={styles.name} style={isSelected ? { color: primaryColor } : {}}>
          {item.nom}
        </p>

        {item.address && (
          <p className={styles.addr}><IconPin size={11} />{item.address}</p>
        )}

        <div className={styles.meta}>
          <span className={`${styles.badge} ${item.isOpen ? styles.badgeOpen : styles.badgeClosed}`}>
            <span className={styles.badgeDot} />
            {item.isOpen ? "Ouvert" : "Fermé"}
          </span>

          {item._dist !== null && (
            <span className={styles.chip}>
              <IconPin size={10} />
              {item._dist < 1 ? `${Math.round(item._dist * 1000)} m` : `${item._dist.toFixed(1)} km`}
            </span>
          )}

          {item.tempsPrep > 0 && (
            <span className={styles.chip}><IconClock size={10} />{item.tempsPrep} min</span>
          )}

          {item.note > 0 && (
            <span className={`${styles.chip} ${styles.chipStar}`}>
              <IconStar size={10} />{item.note.toFixed(1)}
            </span>
          )}

          {item.shifts?.[0] && (
            <span className={styles.chip}>
              <IconClock size={10} />
              {item.shifts[0].open.slice(0, 5)}–{item.shifts[0].close.slice(0, 5)}
            </span>
          )}
        </div>
      </div>

      <div className={styles.actions}>
        <button
          className={styles.dirBtn}
          onClick={(e) => { e.stopPropagation(); onDirections(); }}
          aria-label="Itinéraire"
          title="Voir l'itinéraire"
        >
          <DirectionsIcon style={{ fontSize: 20 }} />
        </button>
        {isSelected && (
          <div className={styles.check} style={{ background: primaryColor }}>
            <IconCheck size={13} />
          </div>
        )}
      </div>
    </div>
  )
);

export default RestaurantItem;